import { BuyingAndSelling } from "./BuyingAndSelling";

export const UniversalRender = BuyingAndSelling;
